import { render, staticRenderFns } from "./dbSortManage.vue?vue&type=template&id=a7770236"
import script from "./dbSortManage.vue?vue&type=script&lang=js"
export * from "./dbSortManage.vue?vue&type=script&lang=js"
import style0 from "./dbSortManage.vue?vue&type=style&index=0&id=a7770236&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports